import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ModalNegocioComponent } from '../../negocios/modal-negocio/modal-negocio.component';

@Component({
  selector: 'app-modal-docs',
  templateUrl: './modal-docs.component.html',
  styleUrls: ['./modal-docs.component.scss']
})
export class ModalDocsComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ModalDocsComponent>,
    public dialog: MatDialog
  ) { }

  ngOnInit(): void {}

  abrirModalNegocio(ev) {  
    let dialog = this.dialog.open(ModalNegocioComponent, {
      data: { negocio: ev, route: 'documentos' },
      minWidth: 300,
      minHeight: 300,
      panelClass: 'modalNegocio'
    });
  }

  fecharModal(ev) {  
    this.dialogRef.close(ev);
  }

  ngOnDestroy(){
    document.querySelector('body').classList.remove('tiraScrollBody');
  }

}
